/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { Logger } from '@app/core';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { HotelBookingCancellationsService } from '@app/hotels/hotel-booking-cancellations/hotel-booking-cancellations.service';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { HotelBookingCancellation } from '@app/hotels/hotel-booking-cancellations/hotel-booking-cancellation.model';
import * as moment from 'moment';
import { environment } from '@env/environment';
import { DataSet } from '@app/shared/kendo/data-set';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';
import { AccessService } from '@app/core/access/access.service';

const log = new Logger('HotelBookingCancellationsListComponent');

@Component({
  selector: 'app-hotel-booking-cancellations-list',
  templateUrl: './hotel-booking-cancellations-list.component.html',
  styleUrls: ['./hotel-booking-cancellations-list.component.scss'],
})
export class HotelBookingCancellationsListComponent extends KendoGridComponent implements OnInit {
  hotelBookingCancellationResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  moment = moment();
  env = environment;
  UserRoleType = UserRoleType;

  constructor(
    private hotelBookingCancellationService: HotelBookingCancellationsService,
    protected kendoGridService: KendoGridService,
    private route: ActivatedRoute,
    private router: Router,
    public accessService: AccessService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      this.state = null;

      if (params.get('booking_id')) {
        this.state = new DataSet().addFilter('booking.id', Number(params.get('booking_id')));
      } else {
        this.state = CustomKendoFilter.getStateFromStorage('HotelBookingCancellationsListComponent');
      }

      this.loadData(this.state);
    });
  }

  /**
   * Load data from API
   */
  loadData(state: DataStateChangeEvent = null) {
    log.debug('loadData');
    this.state = state;
    this.apiQuery
      .setDataSetFilters(state)
      .addIncludes(
        'booking.company',
        'booking.supplier',
        'booking.hotel',
        'booking.events',
        'booking.reservation_agent',
        'booking.contracting_agent',
        'booking.amendment_agent'
      );

    this.hotelBookingCancellationService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.hotelBookingCancellationResponse = response;
      this.data = response.getGridData();
    });

    CustomKendoFilter.pushStateInStorage('HotelBookingCancellationsListComponent', this.state);
  }

  /**
   * @param hotelBookingCancellation HotelBooking object
   */
  delete(hotelBookingCancellation: HotelBookingCancellation) {
    this.hotelBookingCancellationService.destroy(hotelBookingCancellation.id).subscribe(() => {
      this.loadData(this.state);
    });
  }

  clearFilters() {
    this.router.navigate(['/hotel-booking-cancellations']);

    this.apiQuery = new ApiQuery();
    this.loadData();
  }
}
